<template>
  <div class="dss-allergies">
    <tr class="v-data-table__progress" v-if="loading">
      <th colspan="3" class="column">
        <v-progress-linear indeterminate absolute/>
      </th>
    </tr>
    <div class="dss__subheader-main mb-6 mt-5">
      <smart-icon icon="mdi-hand-back-left-off-outline" size="16" class="mr-2" />
      <h3>{{ $ucfirst($t("medicationRejectionOfGuideline.allergies")) }}</h3>
    </div>
    <div v-if="!loading">
      <div class="dss-allergies__entry">
        <div class="d-flex align-center" v-if="patientHasIntoleranceAspirin">
          <v-icon
            class="mr-2"
            :color="$color.coro['warning-500']"
          >
            mdi-arrow-right
          </v-icon>
          <span><strong>{{ $ucfirst($t("dss.allergies.aspirinIntolerance")) }}</strong></span>
        </div>
        <div class="d-flex align-center" v-else-if="patientHasIntoleranceAspirin === null">
          <eva-icon
              class="mr-2"
              :fill="$color.coro['warning-500']"
              name="question-mark-circle-outline"
          />
          <span>{{ $ucfirst($t("dss.allergies.aspirinIntolerance")) }} ({{ unknownString }})</span>
        </div>
        <div class="d-flex align-center" v-else>
          <span class="ml-8">{{ $ucfirst($t("dss.allergies.noAspirinIntolerance")) }}</span>
        </div>
      </div>
      <div class="dss-allergies__entry">
        <div class="d-flex align-center" v-if="patientHasIntoleranceACEI">
          <v-icon
            class="mr-2"
            :color="$color.coro['warning-500']"
          >
            mdi-arrow-right
          </v-icon>
          <span><strong>{{ $ucfirst($t("dss.allergies.ACEIIntolerance")) }}</strong></span>
        </div>
        <div class="d-flex align-center" v-else-if="patientHasIntoleranceACEI === null">
          <eva-icon
              class="mr-2"
              :fill="$color.coro['warning-500']"
              name="question-mark-circle-outline"
          />
          <span>{{ $ucfirst($t("dss.allergies.ACEIIntolerance")) }} ({{ unknownString }})</span>
        </div>
        <div class="d-flex align-center" v-else>
          <span class="ml-8">{{ $ucfirst($t("dss.allergies.noACEIIntolerance")) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dssSubjectMixin from 'dashboard/mixins/dss-subject.mixin';
import SmartIcon from '../../components/Parts/SmartIcon.vue';

/**
 * Component DSSSideEffectsAndAllergies.vue
 *
 * @module DSSSideEffectsAndAllergies
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/views/DSS/DSSSideEffectsAndAllergies.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "DSSSideEffectsAndAllergies",
  mixins: [dssSubjectMixin],
  components: {SmartIcon},
  created() {
    this.$app.eventBus.$on('DSSHeader.saveAndExit', this.saveAndExit)
  },
  beforeDestroy(){
    this.$app.eventBus.$off('DSSHeader.saveAndExit', this.saveAndExit)
  },
  methods: {
    saveAndExit: function(){
      this.$router.push({name: 'DSSMedicationPrescription'})
    }
  },
  computed: {
    patientHasIntoleranceAspirin: function () {
      return this?.dssInfo?.hasIntoleranceForAspirin
    },
    patientHasIntoleranceACEI: function () {
      return this?.dssInfo?.hasIntoleranceForACEInhibitor
    }
  }
};
</script>

<style lang="scss">
.dss-allergies__entry {
  margin-bottom: 10px;
}
</style>
